<div class="maintenance-wrapper">
  <div class="change-language" (click)="changeLanguage()">
    <span>{{ getCurrentLang() | uppercase }}</span>
    <ion-icon name="chevron-down"></ion-icon>
  </div>
  <img src="/assets/images/logo-yova.png" alt="Logo yova" />
  <div>
    <h1><strong>{{ 'PUBLIC.maintenance.title' | translate }}</strong> {{ 'PUBLIC.maintenance.subtitle' | translate }}</h1>
  </div>
</div>
